

import React, { memo, useMemo, useCallback } from 'react';
import cx from 'classnames';
import globalConfig from 'react-global-configuration';

import { Tabs, Icon, Dropdown } from '../../../ui-kit';

import '../styles/_elevate-navigation-tabs.scss';









const NavigationTabs = ({
  history,
  defaultIndex = 0,
  isAdmin,
  isMobile = false
}) => {
  const HIDE_FEATURES = globalConfig.get('HIDE_FEATURES') || {};

  const tabRedirection = useMemo(() => {
    const redirection = ['/'];
    if (!HIDE_FEATURES.manageElevateTemplates) {
      redirection.push('/projects');
    }
    if (!HIDE_FEATURES.manageWorkspaceElevateTemplates) {
      redirection.push('/templates');
    }
    if (!HIDE_FEATURES.manageWorkspaceSplashPages) {
      redirection.push('/splash/manage-templates');
    }
    if (!HIDE_FEATURES.workspaceInsights) {
      redirection.push('/workspace-insights');
    }
    return redirection;
  }, [HIDE_FEATURES, isAdmin]);

  const onChangePageTab = useCallback(
    ({ selectedTabIndex }) => {
      history.push(`${tabRedirection[selectedTabIndex]}`);
    },
    [history, tabRedirection]
  );

  const ELEVATE_PAGES = useMemo(() => {
    if (!isMobile) return [];

    return [
    {
      label: 'My Elevate',
      value: 0
    },
    !HIDE_FEATURES.manageElevateTemplates ?
    {
      label: 'Projects',
      value: 1
    } :
    null,
    isAdmin && !HIDE_FEATURES.manageWorkspaceElevateTemplates ?
    {
      label: 'Templates',
      value: 2
    } :
    null,
    isAdmin && !HIDE_FEATURES.manageWorkspaceSplashPages ?
    {
      label: 'Splash Pages',
      value: 3
    } :
    null,
    isAdmin && !HIDE_FEATURES.workspaceInsights ?
    {
      label: 'Workspace Insights',
      value: 4
    } :
    null].
    filter(Boolean);
  }, [isAdmin, HIDE_FEATURES]);

  return (
    <>
      {(!HIDE_FEATURES.manageElevateTemplates ||
      !HIDE_FEATURES.manageWorkspaceElevateTemplates ||
      !HIDE_FEATURES.manageWorkspaceSplashPages ||
      !HIDE_FEATURES.workspaceInsights) &&
      <div
        className={cx('elevate-navigation-tabs', {
          'elevate-navigation-tabs-mobile': isMobile
        })}>

            {!isMobile ?
        <Tabs
          className="elevate-navigation-tabs__tabs"
          updateSelectedTabIndex={onChangePageTab}
          initialIndex={defaultIndex}
          fixedIndex={defaultIndex}>

                <div title="My Elevates" />
                {!HIDE_FEATURES.manageElevateTemplates &&
          <div title="Projects" />}

                {isAdmin && !HIDE_FEATURES.manageWorkspaceElevateTemplates &&
          <div title="Templates" />}

                {isAdmin && !HIDE_FEATURES.manageWorkspaceSplashPages &&
          <div title="Splash Pages" />}

                {isAdmin &&
          !HIDE_FEATURES.workspaceInsights && <div title="Workspace Insights" />}
              </Tabs> :

        <Dropdown
          onChange={({ value }) => onChangePageTab({ selectedTabIndex: value })}

          options={ELEVATE_PAGES}
          defaultValue={ELEVATE_PAGES.filter(
            ({ value }) => value === defaultIndex
          )}
          type="BUTTON" />}


            {!isMobile &&
        <Icon
          className="elevate-navigation-tabs__settings-gear"
          name="settings2"
          onClick={() => {
            history.push('/settings');
          }} />}


          </div>}

    </>);

};

export default memo(NavigationTabs);